import React, { Component } from "react";
import { connect } from "react-redux";
import FlexView from "react-flexview";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import DailySalesReport from "./dailySalesReport";
import DailySalesReportByTL from "./dailySalesReportByTL";
import MonthToDateSalesReport from "./monthToDateSalesReport";
import MonthToDateSalesReportByTL from "./monthToDateSalesReportByTL";
import YearToDateSalesReport from "./yearToDateSalesReport";
import LastThreeYearsSalesReport from "./lastThreeYearsSalesReport";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import { mapToObjectDDL } from "../../../../common/mapper";
import Container from "../../../../../modules/commons/Container";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import * as ErrorAction from "../../../../../Redux/ErrorRedux";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";

class KacabReportByTL extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataCabang: [],
      dataTL: [],
      kodeCabang: null,
      search: null,
      loading: false,
      idLeader: null,
      doSearch: false,
    };
  }

  componentDidMount = async () => {
    this.fetchDataCabang();
    this.fetchLeaderId();
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.state.kodeCabang?.value !== prevState?.kodeCabang?.value) {
      this.fetchDataTL(this.state.kodeCabang?.value);
    }
  }

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  fetchLeaderId = async () => {
    const idLeader = localStorage.getItem("idLeader");
    const userId = localStorage.getItem("userId");
    
    if (idLeader) {
      this.setState((prevValue) => ({
        ...prevValue,
        idLeader: idLeader,
      }));
      return;
    }
    this.handleTriggerLoading();
    try {
      let res = await fetchDataAsync({
        asyncFn: () => Api.create("NAGAMAS_MASTER_DATA").findUserById(userId),
        menuName:
          "Dashboard Level Kepala Cabang Keatas - Laporan Harian By Team Leader",
        setError: this.props.setError,
      });
      console.log(res);
      
      if (res.ok) {
        localStorage.setItem("idLeader", res.data.data.id);
        this.setState((prevValue) => ({
          ...prevValue,
          idLeader: res.data.data.id,
        }));
      }
    } catch (error) {
      console.log("errors: ", error);
    }
    this.handleTriggerLoading();
  };

  fetchDataCabang = async () => {
    try {
      let res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
        setError: this.props.setError,
        menuName:
          "Dashboard Level Kepala Cabang Keatas - Laporan Harian By Team Leader",
        args: null,
      });
      if (res.ok) {
        let filteredData = res.data.data.filter((item) =>
          this.props.menuAccess
            .map((data) => data.idRefObj)
            .includes(item.kodeCabang),
        );

        if (filteredData.length !== 0) {
          this.setState((prevValue) => ({
            ...prevValue,
            dataCabang: filteredData,
            kodeCabang: mapToObjectDDL(
              filteredData[0].namaDealer,
              filteredData[0].kodeCabang,
            ),
            search: mapToObjectDDL(
              filteredData[0].namaDealer,
              filteredData[0].kodeCabang,
            ),
          }));
        }
      }
    } catch (error) {
      console.log("errors", error);
    }
  };

  fetchDataTL = async (kodeCabang) => {
    try {
      let res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterSales,
        setError: this.props.setError,
        menuName:
          "Dashboard Level Kepala Cabang Keatas - Laporan Harian By Team Leader",
        args: {
          paramFilters: {
            kodeCabang: kodeCabang,
            userNameLead: this.props.auth?.user?.username,
          },
        },
      });
      if (res.ok) {
        this.setState((prevValue) => ({
          ...prevValue,
          dataTL: res.data.data,
        }));
      }
    } catch (e) {
      console.log("error", e);
    }
  };

  handleSearchValueChange = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  handleSearch = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      search: this.state.kodeCabang,
      doSearch: true,
    }));
  };

  handleSuccessSearch = () => {
    this.setState({
      doSearch: false,
    });
  };

  render() {
    return (
      <>
        <Container>
          <FlexView style={{ gap: "20px", alignItems: "center" }}>
            <SimpleDDL
              isClearable
              id="select_options_kode_cabang"
              box="search"
              name="kodeCabang"
              containerclassname="width width-250px"
              placeholder="Nama Cabang"
              menuPosition="fixed"
              options={this.state.dataCabang.map((item) =>
                mapToObjectDDL(item.namaDealer, item.kodeCabang),
              )}
              value={this.state.kodeCabang}
              onChange={(value, { name }) =>
                this.handleSearchValueChange(name, value)
              }
            />
            <SimpleButton
              styles={{ marginBottom: "15px" }}
              onClick={this.handleSearch}
            >
              Cari
            </SimpleButton>
          </FlexView>
          <Tabs>
            <TabList>
              <Tab>Laporan Jualan Harian</Tab>
              <Tab>Laporan Jualan Harian By TL</Tab>
              <Tab>Laporan Jualan Month To Date</Tab>
              <Tab>Laporan Jualan Month To Date By TL</Tab>
              <Tab>Laporan Year To Date</Tab>
              <Tab>Laporan Jualan 3 Tahun Terakhir</Tab>
            </TabList>
            <TabPanel>
              <DailySalesReport
                {...this.props}
                search={this.state.search}
                triggerLoading={this.handleTriggerLoading}
                onSuccessSearch={this.handleSuccessSearch}
                doSearch={this.state.doSearch}
                idLeader={this.state.idLeader}
              />
            </TabPanel>
            <TabPanel>
              <DailySalesReportByTL
                {...this.props}
                search={this.state.search}
                dataTL={this.state.dataTL}
                triggerLoading={this.handleTriggerLoading}
                onSuccessSearch={this.handleSuccessSearch}
                doSearch={this.state.doSearch}
                idLeader={this.state.idLeader}
              />
            </TabPanel>
            <TabPanel>
              <MonthToDateSalesReport
                {...this.props}
                dataTL={this.state.dataTL}
                search={this.state.search}
                triggerLoading={this.handleTriggerLoading}
                onSuccessSearch={this.handleSuccessSearch}
                doSearch={this.state.doSearch}
                idLeader={this.state.idLeader}
              />
            </TabPanel>
            <TabPanel>
              <MonthToDateSalesReportByTL
                {...this.props}
                search={this.state.search}
                kodeCabang={this.state.kodeCabang}
                triggerLoading={this.handleTriggerLoading}
                onSuccessSearch={this.handleSuccessSearch}
                doSearch={this.state.doSearch}
                idLeader={this.state.idLeader}
              />
            </TabPanel>
            <TabPanel>
              <YearToDateSalesReport
                {...this.props}
                search={this.state.search}
                kodeCabang={this.state.kodeCabang}
                triggerLoading={this.handleTriggerLoading}
                onSuccessSearch={this.handleSuccessSearch}
                doSearch={this.state.doSearch}
                usernameLogin={this.props.auth.user.username}
                idLeader={this.state.idLeader}
              />
            </TabPanel>
            <TabPanel>
              <LastThreeYearsSalesReport
                {...this.props}
                search={this.state.search}
                kodeCabang={this.state.kodeCabang}
                idLeader={this.state.idLeader}
                triggerLoading={this.handleTriggerLoading}
                onSuccessSearch={this.handleSuccessSearch}
                doSearch={this.state.doSearch}
              />
            </TabPanel>
          </Tabs>
          {this.state.loading && (
            <SimpleLoadingOverlay active={this.state.loading} />
          )}
        </Container>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (payload) => dispatch(ErrorAction.setError(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(KacabReportByTL);
